import { render, staticRenderFns } from "./ConvictionRecordTableComponent.vue?vue&type=template&id=00c23e3e&scoped=true"
import script from "./ConvictionRecordTableComponent.vue?vue&type=script&lang=ts"
export * from "./ConvictionRecordTableComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c23e3e",
  null
  
)

export default component.exports